module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAnUAAAAPBAMAAABw/yTpAAAAG1BMVEUAAAAiLlgiLlgiLlgiLlgiLlgiLlgiLlgiLljt6VUsAAAACXRSTlMAMywIIhsCFQ8E/52rAAAAn0lEQVRYw+3TwQnCQBCF4Qcb4h6dGNDrkgbCdmCQnHewAZEUYDqwdJ0C9CDsgwx+DTwG5ocW/P1CC4SggE2lvj3h70LqQdbIgMpIwS4yg6o99zc4sXbcU+7ygBchfUto63OVLd0InuynWKMDaKKjYk1MT7Csnoo1+QSSna9ijX4IabtDPPEIisZbsSbPIAgXd8W+tdNVqjtM/oo1YYQvL2KJI+6DVjwqAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/xf/xian2.png
// module id = RThU
// module chunks = 1